export const enum TOPIC {
  workTransport = 'workTransport',
  foodWaste = 'foodWaste',
  co2 = 'co2',
  plastic = 'plastic',
  mindfulCitizen = 'mindfulCitizen',
}
